/**
 * O PAR DE AÇÕES do rodapé de modal (guia §5b, 08/10/2026): Cancelar + Salvar.
 *
 * Dois fantasmas iguais lado a lado não dizem qual é o caminho. A principal carrega PESO (`font-medium` e borda em
 * `primary`), sem precisar de fundo colorido; a secundária é texto fraco, sem borda e sem fundo.
 *
 * - Principal destrutiva (Excluir, Marcar Perdido) NÃO usa `acaoPrincipal`: fica na destrutiva contornada da tela
 *   (`BOTAO_PERIGO`). Só a secundária ao lado dela muda.
 * - Tamanho e `disabled:` ficam em quem chama: aqui mora só o papel.
 */
export const acaoPrincipal = 'bg-central-cartao border border-primary text-central-texto hover:bg-central-elevado font-medium';
export const acaoSecundaria = 'border border-transparent text-central-texto-fraco hover:text-central-texto';
